export enum ProductTypeEnum {
  ETF = "ETF",
  FONDI = "FONDI",
  Obbligazioni = "Obbligazioni",
  BOND = "BOND",
}
